// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { showAdopted, getAnimalsData } from 'actions/animals'

class Adoptions extends React.Component {
	componentDidMount() {
		this.props.dispatch( showAdopted( true ) )

		this.getData()
	}

	componentDidUpdate( prevProps ) {
		const { history, match, location } = this.props

		const path = location.pathname
		const prevPath = prevProps.location.pathname

		let thisPageNumber, lastPageNumber
		let thisPageNumberMatch = path.match( /\/page\/(\d*)/ )
		let lastPageNumberMatch = prevPath.match( /\/page\/(\d*)/ )

		if ( thisPageNumberMatch ) {
			thisPageNumber = thisPageNumberMatch[1]
		}

		if ( lastPageNumberMatch ) {
			lastPageNumber = lastPageNumberMatch[1]
		}

		if ( thisPageNumber != lastPageNumber ) {
			this.getData()
			window.scrollTo( 0, 0 )

			const element = document.getElementById( 'scroll-point-animals' )

			if ( element ) {
				element.scrollIntoView()
			}
		}
	}

	getData = () => {
		const { dispatch, match, location, page } = this.props
		const path = location.pathname

		let pageNumber
		let pageNumberMatch = path.match( /\/page\/(\d*)/ )

		if ( pageNumberMatch ) {
			pageNumber = pageNumberMatch[1]
		}

		if ( pageNumber ) {
			dispatch( getAnimalsData( '', '1', pageNumber ) )
		} else {
			dispatch( getAnimalsData( '', '1' ) )
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( Adoptions )



// WEBPACK FOOTER //
// ./views/main/page/Adoptions.jsx